module.exports = __webpack_public_path__ + "img/user-bg.cbecb507.png";